export const cilCoffee = ["24 24","<path d='M8.977 17.625h4.547c2.885-0.003 5.223-2.341 5.227-5.226v-0.774h1.125c1.864 0 3.375-1.511 3.375-3.375s-1.511-3.375-3.375-3.375v0h-16.125v7.523c0.003 2.885 2.341 5.223 5.226 5.227h0zM18.75 6.375h1.125c1.036 0 1.875 0.839 1.875 1.875s-0.839 1.875-1.875 1.875v0h-1.125zM5.25 6.375h12v6.023c-0.002 2.057-1.669 3.724-3.726 3.727h-4.547c-2.057-0.002-3.724-1.669-3.727-3.726v-0z'></path><path d='M0.75 19.5h22.5v1.5h-22.5v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-coffee.js
// module id = null
// module chunks = 